import React, { useState, useEffect } from "react";
import { Tab, Nav } from "react-bootstrap";
import Calibration from "./Calibration";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Instrument from "./Instrument";

function CalibrationPage() {
  const { id } = useParams();
  const [activeKey, setActiveKey] = useState("calibration");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const stateActiveKey = location.state?.activekey || "calibration";
    setActiveKey(stateActiveKey);
  }, [location.state]);

  const handleSelect = (key) => {
    setActiveKey(key); 
    navigate(`/calibration`, { state: { activekey: key } });
  };

  return (
    <div className="container-fluid">
      <div className="card">
        <Tab.Container activeKey={activeKey} onSelect={handleSelect}>
          <div className="card-header p-0">
            <Nav variant="tabs">
              <Nav.Item>
                <Nav.Link eventKey="calibration" className="tabnav p-3">
                  <strong>Calibration</strong>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="instrument" className="tabnav p-3">
                  <strong>Instrument</strong>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <div className="card-body p-0">
            <Tab.Content>
              <Tab.Pane eventKey="calibration">
                {activeKey === "calibration" && <Calibration />}
              </Tab.Pane>
              <Tab.Pane eventKey="instrument">
                {activeKey === "instrument" && <Instrument />}
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
    </div>
  );
}

export default CalibrationPage;
